import { render } from "./Swiper.vue?vue&type=template&id=1d5379e8&ts=true"
import script from "./Swiper.vue?vue&type=script&setup=true&lang=ts"
export * from "./Swiper.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/home/Swiper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1d5379e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1d5379e8', __exports__)) {
    console.log('reload')
    api.reload('1d5379e8', __exports__)
  }
  
  module.hot.accept("./Swiper.vue?vue&type=template&id=1d5379e8&ts=true", () => {
    console.log('re-render')
    api.rerender('1d5379e8', render)
  })

}


export default __exports__